<template>
  <div class="img">
    <div class="header-moon">
      <div class="header-l">
        <img class="imgTwo" src="../assets/logo.png" alt="" />
      </div>
      <div class="header-r">
        <span>全民数据</span>
      </div>
    </div>
    <div class="footer">
      <div class="footer-one"><span>注册成功</span></div>
      <div class="footer-two">
        <img class="footer-img" src="../assets/dagou.png" alt="" />
      </div>
      <!-- <div class="footer-three"><span>该手机号已注册,请下载后登录</span></div> -->
      <div>
        <el-button class="footer-but" @click="Jump">下载APP</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      correct: true
    }
  },
  methods: {
    Jump () {
      this.$router.push({ name: "download", params: { 'correct': this.correct } });
    }

  }



}
</script>


<style  scoped>
.img {
  position: relative;
  width: 100%;
  height: 100vh;
  background-image: url("../assets/shuzi.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.header-moon {
  padding-top: 50px;
  margin-left: 30%;
}
.imgTwo {
  width: 50px;
  height: 50px;
  border-radius: 8px;
}
.header-l,
.header-r {
  float: left;
}
.header-r {
  padding-top: 5px;
  height: 39px;
  line-height: 39px;
  margin-left: 6px;
  font-size: 25px;
  font-weight: bold;
  color: #ffffff;
}
.footer {
  width: 85%;
  height: 240px;
  background: #359bff;
  border-radius: 8px;
  position: absolute;
  left: 7%;
  bottom: 10%;
  text-align: center;
  opacity: 0.95;
}
.footer-one {
  margin-top: 21px;
  font-size: 18rpx;
  font-weight: bold;
  color: #ffffff;
}
.footer-img {
  margin-top: 31px;
  width: 40px;
  height: 40px;
}
.footer-three {
  margin-top: 34px;
  font-size: 10px;
  font-weight: 500;
  color: #ffffff;
}
.footer-but {
  padding: 0;
  margin-top: 40px;
  width: 220px;
  height: 50px;
  line-height: 30px;
  background: #ffffff;
  border-radius: 10px;
  font-size: 25px;
  font-weight: bold;
  color: #0647bc;
}
</style>